import { render, staticRenderFns } from "./F70ReportComponent.vue?vue&type=template&id=b4f4e28a&scoped=true&"
import script from "./F70ReportComponent.vue?vue&type=script&lang=js&"
export * from "./F70ReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f4e28a",
  null
  
)

export default component.exports